<template>
  <section class="container">
    <section class="viewhtml" v-html="html"></section>
    <section class="my_appoint" @click="toMyAppoint">
      <img src="../../assets/images/icon_appointment.png" alt />
      <span>我的预约</span>
    </section>
    <common-footer class="button">
      <mt-button class="footer_btn btn_default" @click="toAppoint">立即预约</mt-button>
    </common-footer>
  </section>
</template>

<script>
import commonFooter from "../../components/commonFooter";
import util from "../../utils/util";
import { mapState } from "vuex";
import { getIntServTemplateByMarketId } from "../../utils/api.js";
export default {
  name: "houseKeeping",
  components: {
    commonFooter
  },
  data() {
    return {
      index:0,
      obc:'',
      html: ""
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    let query = this.$route.query;
     if (query.index) {
        this.index = query.index;
     }
     console.log(" in new" + this.index)

  },
  activated () {
    this.getIntServTemplateByMarketId();
  },
  methods: {
    toMyAppoint() {
      this.$router.push("/myAppoint");
    },
    toAppoint() {
      if (!this.$store.state.common.userId) {
        this.$router.push({
          path: "/login"
        });
      } else {
        if (
          this.common.userTenantInfoList &&
          this.common.userTenantInfoList.length > 0
        ) {
            var serviceName =encodeURIComponent(this.obc.type) ;
            var serviceType =encodeURIComponent(this.obc.type);
            var id = this.obc.id;
            var url ='/appointForm?serviceName='+serviceName +"&serviceType="+serviceType+"&id="+id;
            this.$router.push({
              path:  url
            });
        } else {
          util.showModal(
            "",
            "你未认证企业,无法进行此操作",
            true,
            "去认证",
            () => {
              this.$router.push("/companyList");
            }
          );
        }
      }
    },
    // 获取数据
    getIntServTemplateByMarketId() {
      util.showLoading();
      getIntServTemplateByMarketId({}).then(res => {
        console.log(res);
        if (res.res.code === 10000 && res.body && res.body.intServTemplate) {
          this.html = res.body.intServTemplate[this.index].orderDesc;
          this.obc  = res.body.intServTemplate[this.index]
          util.hideLoading();
        } else {
          util.hideLoading();
          util.showModal('','项目暂未开启服务',false,'我知道了',()=>{
            this.$router.go(-1)
          })
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.my_appoint {
  position: fixed;
  bottom: 188px;
  right: 0;
  width: 120px;
  height: 120px;
  background: rgba(244, 244, 244, 1);
  border-radius: 8px 0px 0px 8px;
  .flex();
  flex-direction: column;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 36px;
    height: 36px;
    margin-bottom: 4px;
  }
  span {
    display: block;
    height: 32px;
    font-size: 22px;
    color: rgba(102, 102, 102, 1);
    line-height: 32px;
  }
}
.footer_btn {
  width: 100%;
  color: #fff;
  border-radius: 4px;
  background: @color17;
  font-size: 32px;
}
.viewhtml {
  padding: 40px 28px;
  margin-bottom:110px;
  /deep/ li{
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
</style>